(function (app) {

    app.filter('splitCamelCase', function () {
        return function (input) {
            if (typeof input !== "string") {
                return input;
            }
            return input
                //Super hacky method to deal with splitting multiple delimiters without cojuring up voodoo regex
                .split(/([A-Z]+[a-z]*)/).join(':')
                .split('_').join(':')
                .split('-').join(':')
                .split(':').join(' ');
        };
    });

})(window.app, window.angular); //jshint ignore:line